import { resolveCountry } from "./FormatByCountry";

const formatDecimalClean = (value: string | number) => {
  if (!value) return "";
  const country = resolveCountry();
  if (country === "MY") {
    return value
      .toString()
      .replace(/[^0-9.]/g, "")
      .replace(/\.0$/, "")
      .replace(/\.(\d{0,1}).*$/, ".$1");
  }
  // ID: desimal koma
  return value
    .toString()
    .replace(/[^0-9.,]/g, "")
    .replace(/\./g, ",")
    .replace(/,0$/, "")
    .replace(/,(\d{0,1}).*$/, ",$1");
};

export default formatDecimalClean;
